import { Ellipsis } from "@visiblethread/react-components";
import { arrayOf, func, number, shape, string } from "prop-types";
import React from "react";
import { useNavigate } from "react-router-dom";
import { DATE_VARIANTS, formatDate } from "utils/formatDate";
import handleKeyboardClick from "utils/handleKeyboardClick";

import { NO_DUE_DATE } from "../../constants";
import SectionStatusBar from "../SectionStatusBar";
import styles from "./ProposalRow.module.scss";

const formatDueDate = (dueDate) => {
  if (!dueDate) {
    return NO_DUE_DATE;
  }
  const [year, month, day] = dueDate;
  return formatDate(new Date(year, month - 1, day), DATE_VARIANTS.SHORT_DAY_MONTH);
};

const ProposalRow = ({ proposal, onNavigate = () => {} }) => {
  const navigate = useNavigate();
  const {
    proposalId,
    proposalName,
    dueDate,
    notStarted,
    drafting,
    inReview,
    complete,
  } = proposal;
  const total = notStarted + drafting + inReview + complete;
  const completionPercentage =
    total === 0 ? 0 : Math.round((complete / total) * 100);

  const onClick = () => {
    navigate(`/proposals/view/${proposalId}`);
    onNavigate();
  };

  return (
    <li
      className={styles.proposalRow}
      data-testid="section-status-row"
      onClick={onClick}
      onKeyDown={handleKeyboardClick(onClick)}
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
      role="button"
      tabIndex={0}
    >
      <Ellipsis classes={styles.proposalRow__name} text={proposalName} />
      <span className={styles.proposalRow__due}>{formatDueDate(dueDate)}</span>
      <SectionStatusBar
        counts={{ complete, inReview, drafting, notStarted }}
        total={total}
      />
      <span className={styles.proposalRow__count}>{total}</span>
      <span className={styles.proposalRow__percentage}>
        {completionPercentage}%
      </span>
    </li>
  );
};

ProposalRow.propTypes = {
  proposal: shape({
    proposalId: number.isRequired,
    proposalName: string.isRequired,
    dueDate: arrayOf(number),
    notStarted: number.isRequired,
    drafting: number.isRequired,
    inReview: number.isRequired,
    complete: number.isRequired,
  }).isRequired,
  onNavigate: func,
};

export default ProposalRow;
